import React, { useState } from 'react';
import bem from 'utils/bem';
import { toast } from 'react-hot-toast';
import Text from 'components/Text';
import { Button } from 'components/Button';
import EventsField from './EventsField';
import Model from '../../../../model';
import { datetimeFromUTC } from 'utils/dayjs';
import './index.sass';

const { block, el } = bem('transfer-form', 'form');

const TransferForm = ({ orderId, specId, meetingType, utcDate }) => {

    const [ isSubmitting, setIsSubmitting ] = useState(false);
    const [ eventPK, setEventPK ] = useState();
    const { closeTransferForm } = Model.modal;

    const handleSubmit = () => {
        const formData = new FormData();

        formData.append('event_id', eventPK);
        formData.append('order_id', orderId);

        setIsSubmitting(true);

        fetch('/order/update', {
            method: 'POST',
            body: formData
        }).then((promise) => {
            return promise.json();
        }).then((response) => {
            if (response.success) {
                setIsSubmitting(false);
                window.location = '/orders';
                toast.success(`Вы успешно обновили запись`);
            } else {
                setIsSubmitting(false);
                const error = response?.error;
                if (error === 'too_much')
                    toast.error('Переносить запись можно не более 2 раз');
                if (error === 'too_late')
                    toast.error(`Вы пытаетесь изменить запись менее
                    чем за ${ meetingType === 'OFF' ? '24 часа' : '12 часов' } до ее начала, а это невозможно`);
                if (error === 'no_for_ticket') {
                    toast.error('Отмена абонементов запрещена, обратитесь к администратору');
                }
                if (error === 'unpaid')
                    toast.error('Действие не разрешено для неоплаченной записи');
                if (error === 'unknown')
                    toast.error('Произошла неизвестная ошибка, обратитесь к администратору');
                closeTransferForm();
            }
        }).catch(err => {
            setIsSubmitting(false);
            toast.error(`Произошла ошибка ${ err }, обратитесь к администратору`);
            closeTransferForm();
        });
    };

    const { date, time } = datetimeFromUTC(utcDate);
    const formattedDate = `${ date } ${ time }`;

    return (
        <div className={ block() }>
            <div className={ el('top')}>
                <div className={ el('title') }>
                    <Text serif>Перенос записи к специалисту</Text>
                </div>
                <div className={ el('fields') }>
                    <div className={ el('field', 'current') }>
                        <div className={ el('field-label') }>
                            <Text>Текущая дата и время</Text>
                        </div>
                        <div className={ el('field-value') }>
                            <Text>{ formattedDate }</Text>
                        </div>
                    </div>
                    <div className={ el('field', 'new') }>
                        <div className={ el('field-label') }>
                            <Text>Выберите желаемую дату и время</Text>
                        </div>
                        <div className={ el('field-value') }>
                            <EventsField specId={ specId } meetingType={ meetingType } setEventPK={setEventPK}/>
                        </div>
                    </div>
                </div>
            </div>
            <div className={ el('buttons', { 'disabled': isSubmitting }) } >
                <Button mod="gold" className={ el('button', 'yes') } onClick={ handleSubmit }>
                    <Text>Подтвердить</Text>
                </Button>
                <Button mod="transparent-gold" className={ el('button', 'no') } onClick={ closeTransferForm }>
                    <Text>Отмена</Text>
                </Button>
            </div>
        </div>
    );

};

export default TransferForm;
